import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastEditRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/networks/$id/admin/broadcasts/$broadcastId/edit',
)(
  createGroupBroadcastEditRoute({
    kind: 'network',
    fromId: '/_authed/networks/$id/admin/broadcasts/$broadcastId/edit',
  }),
);
